export default __webpack_public_path__ + "static/media/pokeballUpper.c5db1f86.png";